<template>
  <div class="forumUserInfo">
    <el-image
      class="home_header"
      :src="GetResourceUrl('forum/home_header.png')"
    ></el-image>
    <el-image class="avatar" :src="user_info.avatar" fit="cover"></el-image>
    <div class="info">
      <div class="display_name one_lines">
        {{ user_info.display_name }}
      </div>
      <div class="tenant_name one_lines">{{ user_info.tenant_name }}</div>
    </div>

    <div class="description">
      <el-image
        class="desc"
        :src="GetResourceUrl('forum/icon-desc.svg')"
      ></el-image>
      <div class="one_lines">
        {{ user_info.description || l("这个用户很懒，没有填写个人简介") }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ForumUserInfo",
  data() {
    return {
      user_info: {},
    };
  },
  computed: {
    user_id() {
      if (this.$route.query.user_id) {
        return this.$route.query.user_id;
      } else if (this.$store.state.session.user.id) {
        return this.$store.state.session.user.id;
      } else {
        return "";
      }
    },
  },
  created() {
    this.getUserInfo();
  },
  watch: {},
  methods: {
    getUserInfo() {
      console.log("user_id", this.user_id);
      if (this.user_id == this.$store.state.session.user.id) {
        this.user_info = {
          display_name: this.$store.state.session.user.display_name,
          avatar: this.$store.state.session.user.avatar,
          tenant_name: this.$store.state.session.tenant
            ? this.$store.state.session.tenant.name
            : "",
          description: this.$store.state.session.user.description,
        };
      } else {
        this.axios
          .get("/api/account/user_homepage/", {
            params: {
              user_id: this.user_id,
            },
          })
          .then((data) => {
            this.user_info = data;
          });
      }
    },
  },
};
</script>


<style scoped lang="scss">
.forumUserInfo {
  margin-bottom: 10px;
  background: #fff;
  position: relative;
  padding-bottom: 30px;
  .home_header {
    height: 145px;
    width: 100%;
  }
  .avatar {
    width: 98px;
    height: 98px;
    background: #fff;
    border: 2px solid #fff;
    border-radius: 50%;
    position: absolute;
    left: 35px;
    top: 112px;
  }
  .info {
    position: relative;
    width: 100%;
    margin-top: 12px;
    margin-left: 155px;

    .display_name {
      font-size: 20px;
      font-weight: bold;
    }

    .tenant_name {
      font-size: 14px;
      color: #999;
      margin-top: 5px;
    }
  }
  .description {
    color: #666;
    display: flex;
    align-items: center;
    font-size: 16px;
    margin: 30px 38px 0;
    .desc {
      margin-right: 10px;
      width: 16px;
      height: 15px;
    }
    .one_lines {
      max-width: 650px;
    }
  }
}
</style>

